import React from "react";
import classNames from "classnames";

interface PaperProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const BASE_PAPER_CLASS =
  "bg-white rounded-xl shadow-[0_0_20px_rgba(0,0,0,0.1)]";

const Paper = ({ children, className, ...props }: PaperProps) => {
  const paperClass = classNames(BASE_PAPER_CLASS, "p-4 md:p-6", className);

  return (
    <div {...props} className={paperClass}>
      {children}
    </div>
  );
};

export default Paper;
